import {
  VolumeTypeEnum,
  WorkProgressStateEnum,
} from "../../../../store/types/secureVolume.types";

export type InputMode = "number" | "percent";

export const fmt = new Intl.NumberFormat("sv-SE", {
  maximumFractionDigits: 0,
});

export const pctFmt = new Intl.NumberFormat("sv-SE", {
  maximumFractionDigits: 1,
});

export const VOLUME_TYPE_CONFIG: Record<
  VolumeTypeEnum,
  { label: string; color: string }
> = {
  [VolumeTypeEnum.Secured]: { label: "Säkrad", color: "#4caf50" },
  [VolumeTypeEnum.Consumption]: { label: "Förbrukning", color: "#2196f3" },
  [VolumeTypeEnum.Forecast]: { label: "Prognos", color: "#ff9800" },
  [VolumeTypeEnum.InProgress]: { label: "Pågående", color: "#9c27b0" },
  [VolumeTypeEnum.NotSet]: { label: "Ej satt", color: "#9e9e9e" },
};

export const DISPLAY_VOLUME_TYPES = [
  VolumeTypeEnum.Consumption,
  VolumeTypeEnum.Forecast,
  VolumeTypeEnum.Secured,
  VolumeTypeEnum.InProgress,
] as const;

export const PROGRESS_STATE_LABELS: Record<
  WorkProgressStateEnum,
  { label: string; color: "default" | "info" | "warning" | "success" | "error" }
> = {
  [WorkProgressStateEnum.NotSet]: { label: "Ej satt", color: "default" },
  [WorkProgressStateEnum.New]: { label: "Ny", color: "info" },
  [WorkProgressStateEnum.InProgress]: {
    label: "Pågående",
    color: "warning",
  },
  [WorkProgressStateEnum.VolumePresented]: {
    label: "Volym presenterad",
    color: "info",
  },
  [WorkProgressStateEnum.ContractCreated]: {
    label: "Avtal skapat",
    color: "warning",
  },
  [WorkProgressStateEnum.ContractSent]: {
    label: "Avtal skickat",
    color: "warning",
  },
  [WorkProgressStateEnum.ContractSigned]: {
    label: "Avtal signerat",
    color: "success",
  },
  [WorkProgressStateEnum.Completed]: {
    label: "Klart",
    color: "success",
  },
  [WorkProgressStateEnum.Submitted]: {
    label: "Inskickat till Zynergy",
    color: "success",
  },
};
